import React from 'react';
import { useTranslation } from 'react-i18next';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';

import scss from './SelectedMediaEmpty.module.scss';

function SelectedMediaEmpty() {
  const { t } = useTranslation('story');

  return (
    <div className={scss.wrapper}>
      <div className={scss.iconWrap}>
        <PermMediaOutlinedIcon className={scss.icon} />
      </div>
      <span className={scss.title}>{t('noSelectedMedia')}</span>
      <p className={scss.description}>{t('emptySelectedMediaDescription')}</p>
    </div>
  );
}

export default SelectedMediaEmpty;
